import React, { useState } from "react";
import { Box, IconButton, InputBase, Tooltip } from "@mui/material";
import Search from "@mui/icons-material/Search";
import ListOutlined from "@mui/icons-material/ListOutlined";

const NavbarSearchBar = ({
  searchRef,
  searchPromptText,
  onSearchChange,
  onKeyDown,
  onSearch,
  onOpenSearch,
  theme,
}) => {
  const [focused, setFocused] = useState(false);
  const isDark = theme.palette.mode === "dark";
  const accent = theme.palette.primary.main;

  return (
    <Box
      ref={searchRef}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        width: "32%",
        minWidth: 280,
        px: 1.25,
        py: 0.25,
        height: 36,
        borderRadius: "10px",
        backgroundColor: isDark
          ? "rgba(255,255,255,0.04)"
          : "rgba(15,23,42,0.035)",
        border: `1px solid ${focused ? accent : theme.palette.divider}`,
        boxShadow: focused
          ? `0 0 0 3px ${accent}1f`
          : "inset 0 1px 0 rgba(255,255,255,0.02)",
        transition:
          "border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease",
      }}
    >
      <Search
        sx={{
          fontSize: 18,
          color: focused ? accent : theme.palette.text.secondary,
          transition: "color 160ms ease",
        }}
      />
      <InputBase
        placeholder="Search OpsBlox…"
        fullWidth
        value={searchPromptText}
        onChange={onSearchChange}
        onKeyDown={onKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        sx={{
          fontSize: "0.95rem",
          letterSpacing: "0.005em",
          "& input::placeholder": {
            color: theme.palette.text.secondary,
            opacity: 0.7,
          },
        }}
      />
      <Tooltip title="Search">
        <IconButton
          aria-label="Search"
          onClick={onSearch}
          size="small"
          sx={{
            borderRadius: "8px",
            color: theme.palette.text.secondary,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
              color: accent,
            },
          }}
        >
          <Search sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="Previous searches">
        <IconButton
          aria-label="View previous searches"
          onClick={onOpenSearch}
          size="small"
          sx={{
            borderRadius: "8px",
            color: theme.palette.text.secondary,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
              color: accent,
            },
          }}
        >
          <ListOutlined sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default NavbarSearchBar;
